import type { PendingForm } from '@/api/types/Forms'
import { Glyph } from '@/components/svgs/Glyph'
import { colors } from '@/constants/colors'
import { Turning } from '@/ui/core/motion'
import { Pressable } from '@/ui/core/pressable'
import { Text } from '@/ui/core/typography'
import { useState } from 'react'
import { View } from 'react-native'
import { TodoSheet } from './TodoSheet'

/**
 * The to-dos as a row: a turning asterisk and a coral dot; the count lives in the label for
 * VoiceOver. Tapping it always opens the
 * list, even for a single thing, so the row's promise is the same every time. Rendered only while
 * there is something to do.
 */
export const TodoRow = ({ forms }: { forms: PendingForm[] }) => {
	const [open, setOpen] = useState(false)
	const first = forms[0]
	if (!first) return null

	return (
		<>
			<Pressable
				onPress={() => setOpen(true)}
				accessibilityRole="button"
				accessibilityLabel={`To Do, ${forms.length} quick ${
					forms.length === 1 ? 'thing' : 'things'
				}`}
				className="min-h-[64px] flex-row items-center rounded-note bg-white px-4 py-3"
				style={{ gap: 12 }}
			>
				<View className="h-10 w-10 items-center justify-center rounded-full bg-ground">
					<Turning>
						<Glyph name="asterisk" size={20} color={colors.ink} />
					</Turning>
				</View>
				<Text size="body0" weight="bold" className="flex-1">
					To Do
				</Text>
				<View className="h-2 w-2 rounded-full bg-accent" />
				<Glyph name="chevron" size={14} color={colors.ink} />
			</Pressable>
			<TodoSheet open={open} onClose={() => setOpen(false)} forms={forms} />
		</>
	)
}
